import { useEffect } from "react";

/**
 * Hook that executes a handler when it detects a click outside the provided ref
 * @param  {HtmlRef}  ref     Parent component that will detect the click outside
 * @param  {Function} handler callback function that executes when a click outside is detected
 */
export const useOutsideClick = (ref, handler) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (handler) {
          handler(event);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
};
